import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';
import { accessLocalStorage, exportDeleteMohs } from '../../../services';

import Loading from '../../../components/Loading/LoadingModule';
import './MohView.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

function MohView() {
  const getItensStateGlobal = useContext(PbxContext);
  const { itemsSelectedToEdit } = getItensStateGlobal;

  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [mohData, setMohData] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [alert, setAlert] = useState({ show: false, type: '', message: '' });

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    if (!dataUser) return history.push('/');

    if (!itemsSelectedToEdit) {
      return history.push('/config/musica-de-espera/lista');
    }

    setMohData({ name: itemsSelectedToEdit });
    setLoading(false);
  }, [history, itemsSelectedToEdit]);

  const handleDelete = () => {
    setAlert({ show: false, type: '', message: '' });
    setShowConfirmDelete(true);
  };

  const confirmDelete = async () => {
    setShowConfirmDelete(false);
    setDeleting(true);

    try {
      const result = await exportDeleteMohs(mohData.name);

      if (result.success) {
        setAlert({ show: true, type: 'success', message: 'Música de espera excluída com sucesso!' });
        setTimeout(() => {
          history.push('/config/musica-de-espera/lista');
        }, 2000);
        return;
      }

      setAlert({ show: true, type: 'danger', message: result.error });
    } finally {
      setDeleting(false);
    }
  };

  const handleEdit = () => {
    history.push('/config/musica-de-espera/editar');
  };

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  const formatDisplayName = (name) => {
    if (!name) return '';
    if (name.startsWith('moh-')) {
      const parts = name.substring(4).split('-');
      if (parts.length > 1) {
        return parts[0];
      }
    }
    return name;
  };

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div className="moh-view-container">
          <div className="moh-view-header">
            <div className="moh-view-title-wrapper">
              <svg className="moh-view-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
              </svg>
              <div>
                <h1 className="moh-view-title">Detalhes da Música de Espera</h1>
                <p className="moh-view-subtitle">Visualize as informações da música de espera</p>
              </div>
            </div>
          </div>

          <div className="alerts-section">
            {alert.show && (
              <div className={`alert-message alert-${alert.type}`}>
                <div className="alert-header">
                  <span>{alert.type === 'success' ? 'Sucesso!' : 'Erro!'}</span>
                  <button className="alert-close" aria-label="delete" onClick={() => setAlert({ show: false, type: '', message: '' })}>×</button>
                </div>
                <div className="alert-body">{alert.message}</div>
              </div>
            )}

            {showConfirmDelete && (
              <div className="alert-message alert-danger">
                <div className="alert-header">
                  <span>Atenção!</span>
                  <button className="alert-close" aria-label="delete" onClick={() => setShowConfirmDelete(false)}>×</button>
                </div>
                <div className="alert-body">
                  Tem certeza que deseja excluir esta música de espera?
                </div>
                <div className="alert-actions">
                  <button className="btn-alert btn-alert-confirm" onClick={confirmDelete}>
                    <FontAwesomeIcon icon={faTrash} />
                    Confirmar
                  </button>
                  <button className="btn-alert btn-alert-cancel" onClick={() => setShowConfirmDelete(false)}>
                    Cancelar
                  </button>
                </div>
              </div>
            )}
          </div>

          {mohData && (
            <div className="moh-details-card">
              <div className="details-section-title">Informações Básicas</div>
              <div className="details-grid">
                <div className="detail-item">
                  <span className="detail-label">Nome</span>
                  <span className="detail-value">{formatDisplayName(mohData.name)}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Cliente</span>
                  <span className="detail-value">{mohData.accountcode || (mohData.name ? mohData.name.split('-').pop() : '')}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Modo</span>
                  <span className="detail-value">{mohData.mode === 'files' ? 'Ler Pasta' : mohData.mode === 'playlist' ? 'Música Única' : mohData.mode || '-'}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Ordenação</span>
                  <span className="detail-value">{mohData.sort === 'name' ? 'Nome' : mohData.sort === 'random' ? 'Aleatório' : mohData.sort || '-'}</span>
                </div>
              </div>

              <div className="details-section-title">Localização</div>
              <div className="details-grid">
                <div className="detail-item">
                  <span className="detail-label">Diretório</span>
                  <span className="detail-value">{mohData.directory || '-'}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Arquivo</span>
                  <span className="detail-value">{mohData.entry || '-'}</span>
                </div>
              </div>
            </div>
          )}

          <div className="moh-actions">
            <Link to="/config/musica-de-espera/lista" className="btn-action btn-back">
              <FontAwesomeIcon icon={faArrowLeft} />
              Voltar
            </Link>
            <button className="btn-action btn-edit-view" onClick={handleEdit} disabled={deleting}>
              <FontAwesomeIcon icon={faPen} />
              Editar
            </button>
            <button className="btn-action btn-delete-view" onClick={handleDelete} disabled={deleting}>
              <FontAwesomeIcon icon={faTrash} />
              {deleting ? 'Excluindo...' : 'Excluir'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default MohView;
